import React from 'react';

const ArrowDown: React.FC = () => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M7 10L12.5 15.5L18 10" stroke="currentColor" />
    </svg>
  );
};

export default ArrowDown;
